import { atom } from 'jotai';

const qtyUpdate = atom<boolean>(true);
qtyUpdate.debugLabel = 'qtyUpdate';

export default qtyUpdate;
